<div class="ng-progress" *ngIf="state?.active" [class.ng-progress-active]="state.active" [class.thick]="thick">
    <div class="bar" [ngStyle]="barStyles()">
        <div class="bar-shadow" [ngStyle]="shadowStyles()"></div>
    </div>
    <div *ngIf="showSpinner" class="spinner" [ngClass]="spinnerClasses">
        <div class="bounce1"></div>
        <div class="bounce2"></div>
        <div class="bounce3"></div>
    </div>
</div>
